import Modal from './standard'

export default Modal
